import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE = "LeadTitan";
const DEFAULT_DESC =
  "LeadTitan connects homeowners with vetted local trade pros. Post your project free, get matched in minutes — pros pay only for the leads they want.";

/**
 * Per-route <title>, description, canonical and social share tags.
 * Static fallbacks live in public/index.html for crawlers that skip JS.
 */
export default function Seo({ title, description, path, image, noindex = false, type = "website" }) {
  // index.html carries site-level tags for crawlers that never run JS. Once React
  // is alive they would duplicate the per-route tags, so drop them.
  useEffect(() => {
    document.head.querySelectorAll("[data-seo-fallback]").forEach((el) => el.remove());
  }, []);

  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const url = `${origin}${path ?? (typeof window !== "undefined" ? window.location.pathname : "")}`;
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Hire a Pro. Win the Job.`;
  const desc = description || DEFAULT_DESC;
  const img = `${origin}${image || "/og-image.jpg"}`;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
